export default "__VITE_ASSET__D3ALqfE1__"